<template>
  <div class="print-labels-view">
    <div class="p-10 ml-13">
      <div class="print-labels-view-header">
        <tab-buttons
          class="print-labels-view-header-tab-buttons"
          :tabs="tabs"
        />

        <printer-connection-status
          label-text="Status:"
          @download-plugin-requested="handleDownloadPluginRequested"
        />

        <printer-config-button
          v-if="toggle.printerPlugin && webSocketStatus.connectionState === 'connected'"
          tooltip-direction="left"
          tooltip-text="Configurações da Impressora"
        />

        <printer-calibration />

        <printer-help-button />

        <create-batch-modal />
      </div>

      <transition
        name="fade"
        mode="out-in"
      >
        <router-view />
      </transition>
    </div>

    <printer-plugin-download-modal
      ref="webSocketPluginDownloadModal"
      ref-name="webSocketPluginDownloadModal"
    />
  </div>
</template>

<script>
import { getPrintListLocation } from '@/utils/print-filter-session'
import { mapActions, mapGetters } from 'vuex'

import { eventBus, OPEN_PRINTER_PLUGIN_MODAL } from '@/api/eventbus'
import PrintWebSocketService from '@/services/PrintWebSocketService'

import TabButtons from '@/components/common/TabButtons'
import CreateBatchModal from '@/components/PrintLabels/CreateBatchModal'
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal'
import PrinterConnectionStatus from '@/components/common/printer/PrinterConnectionStatus'
import PrinterCalibration from '@/components/common/calibration/PrinterCalibration'
import PrinterConfigButton from '@/components/common/printer/PrinterConfigButton'
import PrinterHelpButton from '@/components/common/printer/PrinterHelpButton'

export default {
  name: 'PrintLabels',
  components: {
    TabButtons,
    CreateBatchModal,
    PrinterPluginDownloadModal,
    PrinterConnectionStatus,
    PrinterCalibration,
    PrinterConfigButton,
    PrinterHelpButton,
  },
  computed: {
    ...mapGetters(['toggle', 'webSocketStatus']),
    tabs() {
      return [
        {
          label: 'Lotes',
          to: '/print-tag/batches',
          query: getPrintListLocation('batches', this.$route.query).query,
        },
        {
          label: 'Amostras',
          to: '/print-tag/samples',
          query: getPrintListLocation('samples', this.$route.query).query,
        },
      ]
    },
  },
  mounted() {
    if (this.toggle.printerPlugin) {
      this.connectWebSocket()
    }

    eventBus.$on(OPEN_PRINTER_PLUGIN_MODAL, () => {
      this.$refs.webSocketPluginDownloadModal.forceOpen()
    })
  },
  beforeDestroy() {
    eventBus.$off(OPEN_PRINTER_PLUGIN_MODAL)
  },
  methods: {
    ...mapActions(['initializeWebSocket', 'updateWebSocketStatus']),
    async connectWebSocket() {
      try {
        await PrintWebSocketService.disconnect()
        await new Promise(resolve => setTimeout(resolve, 2000))

        this.updateWebSocketStatus('connecting')

        await this.initializeWebSocket()

        if (this.webSocketStatus.connectionState !== 'connected') {
          throw new Error('WebSocket connection failed')
        } else if (this.webSocketStatus.hasNewVersion) {
          this.$nextTick(() => {
            this.$refs.webSocketPluginDownloadModal.open()
          })
        }
      } catch (error) {
        console.error('Erro na conexão:', error)

        this.updateWebSocketStatus('disconnected')

        this.$nextTick(() => {
          this.$refs.webSocketPluginDownloadModal.open()
        })
      }
    },
    handleDownloadPluginRequested() {
      this.$refs.webSocketPluginDownloadModal.forceOpen()
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../static/stylesheets/variables' as *;

.print-labels-view {
  height: $contentContainerHeight;
  padding-top: $mainHeaderHeight;

  &-header {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;

    &-tab-buttons {
      flex: 1;
      margin-bottom: 0 !important;
    }
  }
}
</style>
